<script setup>

const props = defineProps({
    overtime: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['delete'])

function remove(id){
    emit('delete', id)
}

function formatTime(datetime){
    return dayjs(datetime).format('YYYY-MM-DD HH:mm')
}

</script>

<template>
    <div class=" rounded bg-gray-400 px-4 py-4">
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Start</div>
            <div class="text-2xl  text-white">{{formatTime(overtime.begin_time)}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">End</div>
            <div class="text-2xl text-white">{{formatTime(overtime.end_time)}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Type</div>
            <div class="text-2xl text-white">{{overtime.ot_type}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Reason</div>
            <div class="text-2xl text-white">{{overtime.remark}}</div>
        </div>
        <div class="flex-col ">
            <div class="text-gray-100 my-1 font-bold">Status</div>
            <div class="text-2xl text-white">{{ overtime.status === 'approved' ? '✅ approved' : '⏳ waiting for review' }}</div>
        </div>
        <div class="flex justify-center mt-4">
            <button v-if="overtime.status === 'waiting'" @click="remove(overtime.id)" class="px-4 py-4 text-center text-xl rounded bg-rose-400 hover:bg-rose-600 text-white">
                <span> 🧹 cancel apply</span>
            </button>
        </div>
    </div>
</template>
